import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Features from '../../components/layouts/Features';
import circles from '../../images/undraw_circles_y7s2.svg';
import data from '../../images/undraw_all_the_data_h4ki.svg';
import code from '../../images/undraw_code_review_l1q9.svg';
import update from '../../images/undraw_update_uxn2.svg';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Features;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`No more clicking`}</h2>
    <img src={circles} />
    <p>{`Stop wasting time on low value and frustrating tasks. Focus on your ideas, let us do the dirty work.`}</p>
    <h2>{`Sharing is caring`}</h2>
    <img src={data} />
    <p>{`Who has never taken a screenshots of a Google draw just to paste it in a doc somewhere?`}</p>
    <p>{`With GraphUp sharing is simple, as it should be`}{` `}{`❤️`}</p>
    <h2>{`It stays updated`}</h2>
    <img src={update} />
    <p>{`Have you ever been that person who needs to update a diagram on a doc? Looking for the original file but finally re-creating it from scratch just for a typo?`}</p>
    <p>{`Gone are those days, just update your graph directly from GraphUp and all integrations are automatically updated for you.`}</p>
    <h2>{`Automation`}</h2>
    <img src={code} />
    <p>{`Because GraphUp works with raw data, you can generate and update diagrams right from your code in minutes.`}</p>
    <p>{`Integrate GraphUp in your `}<abbr title="Continuous integration and continuous delivery">{`CI-CD`}</abbr>{` pipeline and build rich documentations automatically.`}</p>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      